import { render, staticRenderFns } from "./NuevaAsistencia.vue?vue&type=template&id=1341ce71"
import script from "./NuevaAsistencia.vue?vue&type=script&lang=js"
export * from "./NuevaAsistencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports